<template>
        <v-dialog v-model="show" max-width="800px">
            <v-card v-if="show">
                <v-card-title>
                    <span class="subtitle-1">상품권 발행</span>
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col>
                            <v-select v-model="order.platform" label="플랫폼 *" :items="platforms" persistent-placeholder hide-details ></v-select>
                        </v-col>
                        <v-col>
                            <v-select v-model="order.giftcard" :items="giftcards.filter(giftcard => giftcard.platform == order.platform)" item-text="subname" return-object label="상품권 *" persistent-placeholder hide-details></v-select>
                        </v-col>
                    </v-row>

                    <v-row>
                        <!-- <v-col><v-text-field label="주문번호 *" persistent-placeholder hide-details /></v-col> -->
                        <v-col><v-text-field v-model="order.quantity" label="발권수량 *" persistent-placeholder hide-details /></v-col>
                        <v-col></v-col>
                    </v-row>

                    <v-row>
                        <v-col><v-text-field v-model="order.sender.username" label="구매자 아이디(세일러북 아이디) *" persistent-placeholder hide-details /></v-col>
                        <v-col><v-text-field v-model="order.sender.phone" label="구매자 연락처 *" persistent-placeholder hide-details /></v-col>
                    </v-row>

                    <v-row>
                        <v-col><v-text-field v-model="order.receiver.name" label="받는사람 이름" persistent-placeholder hide-details /></v-col>
                        <v-col></v-col>
                    </v-row>
                    <v-row>
                        <v-col><v-text-field v-model="order.receiver.phone" label="받는사람 연락처(핸드폰) *" persistent-placeholder hide-details placeholder='"-" 를 제외한 숫자만 입력해주세요' /></v-col>
                        <v-col><v-text-field v-model="order.receiver.email" label="받는사람 이메일" persistent-placeholder hide-details /></v-col>
                    </v-row>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="close">취소</v-btn>
                    <v-btn color="primary" text @click="save">발행</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
</template>

<script>
import api from "@/api";
export default {
    data(){
        return {
            show: false,
            issue: null,
            giftcards: [],
            platforms: [] ,
            mode: null,

            order: {
                giftcard: null,
                platform: null,
                quantity: null,
                sender: {
                    username: null,
                    phone: null
                },
                receiver: {
                    name: null,
                    phone: null,
                    email: null
                },
            }
        }
    },
    async mounted() {
        await this.init()
    },
    methods: {
        async init() {
            const { giftcards } = await api.console.shop.giftcards.gets({
                headers: {
                    skip: 0,
                    limit: 0
                }
            });
            giftcards.forEach((giftcard) => {
                giftcard.subname = `${giftcard.name} (${giftcard.faceamt.format()}원)`;
            })
            this.giftcards = giftcards;
            this.platforms = giftcards.reduce((platforms, giftcard) => { return 0 < platforms.indexOf(giftcard.platform) ? platforms : [...platforms, giftcard.platform] }, []);
        },
        validate(){
            try{
                if(!this.order.platform) throw Error("플랫폼을 선택해주세요.")
                if(!this.order.giftcard) throw Error("상품권을 선택해주세요.")
                if(!this.order.quantity) throw Error("발권수량을 입력해주세요.")
                if(!this.order.sender.username) throw Error("구매자 아이디를 입력해주세요.")
                if(!this.order.sender.phone) throw Error("구매자 연락처를 입력해주세요.")
                if(!this.order.receiver.name) throw Error("받는사람의 이름을 입력해주세요.")
                if(!this.order.receiver.phone) throw Error("받는사람의 연락처를 입력해주세요.")
                if(!this.order.receiver.email) throw Error("받는사람의 이메일을 입력해주세요.")
                return true
            }
            catch(error){
                alert(error.message)
                return false
            }
        },
        open(){
            this.show = true;
        },
        close(){
            this.show = false;
        },
        async save(){
            if(this.validate()){
                await api.console.shop.orders.post({
                    ...this.order,
                    mode: this.mode,
                })
                this.$emit("search")
                alert('상품권이 수동발권 되었습니다')
    
                this.close();
            }
        }
    },
    watch:{
        show() {
            if(!this.show){
                this.order = {
                    giftcard: null,
                    platform: null,
                    quantity: null,
                    sender: {
                        username: null,
                        phone: null
                    },
                    receiver: {
                        name: null,
                        phone: null,
                        email: null
                    },
                }
            }
        }
    }
}
</script>